<template>
  <div class="commonBox paySuccessBox">
    <van-icon name="wechat-pay" size="80" color="#1AAD19"/>
    <div class="success">支付成功</div>
    <div class="autoTip" v-if="countdown > 0">{{ countdown }} 秒后自动跳转我的捐赠证书</div>
    <div class="btns">
      <div class="loginBtn emptyClass" @click="getUrlParam(1)">返回项目</div>
      <div class="loginBtn" @click="getUrlParam(2)">查看证书</div>
    </div>
    
  </div>
</template>

<script>
// import {getOrderInfo} from '@/api/index.js'
export default {
  data () {
    return {
      outTradeNo:"",//订单号
      id:"",//项目id
      logId:"",
      countdown: 3,
      autoJumped: false,
      timer: null,
      startAt: 0,
    }
  },
  components: {

  },
  mounted() {
    this.parseOutTradeNo()
    // 通知微信点金计划父窗口：自定义页面已准备好
    // 延迟 100ms，确保父窗口 iframe 环境已就绪
    setTimeout(() => {
      let mchData ={
        action:'onIframeReady',
        displayStyle:'SHOW_CUSTOM_PAGE',
        height: 960
      }
      let postData = JSON.stringify(mchData)
      parent.postMessage(postData, 'https://payapp.weixin.qq.com')
    }, 100)

    // 自动跳转证书页：如果有点金计划自定义页，3秒后自动跳；
    // 使用 Date.now() 轮询，避免 iframe 里 setInterval 被微信 WebView 冻结导致倒计时卡住。
    if (this.outTradeNo) {
      this.startAutoJump()
    }
  },
  beforeDestroy() {
    this.clearAutoJump()
  },
  methods: {
    parseOutTradeNo() {
      var reg = new RegExp("(^|&)" + 'out_trade_no' + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        this.outTradeNo = unescape(r[2])
      }
    },
    startAutoJump() {
      this.startAt = Date.now()
      this.tick()
    },
    tick() {
      if (this.autoJumped) return
      const elapsed = (Date.now() - this.startAt) / 1000
      const remaining = Math.max(0, Math.ceil(3 - elapsed))
      this.countdown = remaining
      if (remaining <= 0) {
        this.clearAutoJump()
        this.goCert()
        return
      }
      // 每 200ms 检查一次，兼顾平滑度和性能
      this.timer = setTimeout(() => {
        this.tick()
      }, 200)
    },
    clearAutoJump() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },
    getUrlParam(type) {
      this.parseOutTradeNo()
      if (!this.outTradeNo) return
      this.clearAutoJump()
      this.autoJumped = true
      if(type==1){
        this.goBack()
      }else{
        this.goCert()
      }
    },
    //返回项目
    goBack(){
      this.autoJumped = true
      let origin=window.location.origin
      let mchData ={
        action:'jumpOut', 
        jumpOutUrl:`${origin}/project/projectDetail?outTradeNo=${this.outTradeNo}`
      }
      let postData = JSON.stringify(mchData)
      parent.postMessage(postData, 'https://payapp.weixin.qq.com')
    },
    //查看证书
    goCert(){
      this.autoJumped = true
      let origin=window.location.origin
      let mchData ={
        action:'jumpOut', 
        jumpOutUrl:`${origin}/project/certificate?outTradeNo=${this.outTradeNo}`
      }
      let postData = JSON.stringify(mchData)
      parent.postMessage(postData, 'https://payapp.weixin.qq.com')
    }
  },
}

</script>
<style scoped lang='scss'>
.paySuccessBox{
  padding-top: 300rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  .success{
    margin: 20rem 0 10rem;
    font-size: 30rem;
  }
  .autoTip{
    margin-bottom: 40rem;
    font-size: 24rem;
    color: #666;
  }
  .loginBtn {
    width: 600rem;
    height: 82rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30rem;
    color: #fff;
    background-color: #b8211a;
    border-radius: 41rem;
    margin: 65rem auto 30rem;
  }
  .emptyClass{
    color: #b8211a;
    background-color: #fff;
    border: 1px solid #b8211a;
  }
}
</style>
